module.exports = __webpack_public_path__ + "img/Banner2中文.976fc0ec.png";